export const  parseStringToNode = (string: string) =>{
  var doc = new DOMParser().parseFromString(string, "text/html");
  const decodedString = doc.documentElement.textContent;
  const newHead = document.createElement('head');
  newHead.innerHTML = decodedString ?? "";
  return (newHead.childNodes)
}